import Vue from 'vue'
import SummaryDefault from '@/components/summary_default.vue'
import i18n from '@/i18n.js'

export class BrickInfos {
  constructor() {
    this.input = ' > '
    this.output = ' > '
    this.back_classes = ['fas']
    this.front_classes = ['fas']
    this.name = ''
    this.associated_class_name = ''
    this.editing_component = undefined
    this.editing_component_name = ''
    this.summary_component = SummaryDefault
    this.summary_component_name = 'SummaryDefault'
    this.element_preview_type = 'ColumnstoreViewerMain'
    this.descriptions = {
      en: {
        short_tooltip_description: 'Short description',
        full_tooltip_description: 'Full description',
        navbar_name: '',
      },
      fr: {
        short_tooltip_description: 'Description simple',
        full_tooltip_description: 'Description complète',
        navbar_name: '',
      },
    }
    // this.short_tooltip_description = 'Short description'
    // this.full_tooltip_description = 'Full description'
    // this.navbar_name = ''
    this.background_color = 'grey'
    this.component = undefined
  }
}

let bricks_infos = {}

export { bricks_infos }

Vue.component('SummaryDefault', SummaryDefault)

function transform_locale_keys(locale_descriptions, name) {
  let res = locale_descriptions
  res[name + '_short_tooltip'] = res['short_tooltip_description']
  res[name + '_full_tooltip'] = res['full_tooltip_description']
  res[name + '_navbar'] = res['navbar_name']
  delete res['short_tooltip_description']
  delete res['full_tooltip_description']
  delete res['navbar_name']
  return res
}

export function brick_registerer(single_brick_infos) {
  bricks_infos[single_brick_infos.name] = single_brick_infos

  i18n.mergeLocaleMessage(
    'en',
    transform_locale_keys(
      (single_brick_infos.descriptions || {})['en'],
      single_brick_infos.name
    )
  )
  i18n.mergeLocaleMessage(
    'fr',
    transform_locale_keys(
      (single_brick_infos.descriptions || {})['fr'],
      single_brick_infos.name
    )
  )

  Vue.component(
    single_brick_infos.editing_component_name,
    single_brick_infos.editing_component
  )
}

export function brick_info_from_name(brick_short_name) {
  let res = bricks_infos[brick_short_name] || {}
  return res
}

function register_none_infos() {
  let none_infos = new BrickInfos()

  none_infos.input = '   '
  none_infos.output = '   '
  none_infos.back_classes = []
  none_infos.front_classes = []
  none_infos.name = 'none'
  none_infos.descriptions = {
    en: {
      short_tooltip_description: '',
      full_tooltip_description: '',
      navbar_name: '',
    },
    fr: {
      short_tooltip_description: '',
      full_tooltip_description: '',
      navbar_name: '',
    },
  }
  none_infos.background_color = ''
  brick_registerer(none_infos)
}

function register_modify_infos() {
  let modify_infos = new BrickInfos()

  modify_infos.input = '   '
  modify_infos.output = '   '
  modify_infos.back_classes = ['far', 'fa-square', 'text-blue']
  modify_infos.front_classes = ['fas', 'fa-cog', 'text-blue']
  modify_infos.name = 'modify'
  modify_infos.descriptions = {
    en: {
      short_tooltip_description: 'Modify',
      full_tooltip_description: 'Goes to brick edition',
      navbar_name: 'Modify',
    },
    fr: {
      short_tooltip_description: 'Modifier',
      full_tooltip_description: 'Editer la brique',
      navbar_name: 'Modifier',
    },
  }
  modify_infos.background_color = 'blue'

  brick_registerer(modify_infos)
}

function register_delete_infos() {
  let delete_infos = new BrickInfos()

  delete_infos.input = '   '
  delete_infos.output = '   '
  delete_infos.back_classes = ['far', 'fa-octagon', 'text-red']
  delete_infos.front_classes = ['fas', 'fa-trash-alt', 'text-red']
  delete_infos.name = 'delete'
  delete_infos.descriptions = {
    en: {
      short_tooltip_description: 'Delete',
      full_tooltip_description: 'Deletes the brick',
      navbar_name: 'Delete',
    },
    fr: {
      short_tooltip_description: 'Supprimer',
      full_tooltip_description: 'Supprime la brique',
      navbar_name: 'Supprimer',
    },
  }
  delete_infos.background_color = 'red'

  brick_registerer(delete_infos)
}

function register_cancel_infos() {
  let cancel_infos = new BrickInfos()

  cancel_infos.input = '   '
  cancel_infos.output = '   '
  cancel_infos.back_classes = ['far', 'fa-circle', 'text-blue']
  cancel_infos.front_classes = ['fas', 'fa-ban', 'text-blue']
  cancel_infos.name = 'cancel'
  cancel_infos.descriptions = {
    en: {
      short_tooltip_description: 'Cancel',
      full_tooltip_description: 'Cancels the selection',
      navbar_name: 'Cancel',
    },
    fr: {
      short_tooltip_description: 'Annuler',
      full_tooltip_description: 'Annule la sélection',
      navbar_name: 'Annuler',
    },
  }
  cancel_infos.background_color = 'blue'

  brick_registerer(cancel_infos)
}

function register_actions_infos() {
  register_none_infos()
  register_modify_infos()
  register_delete_infos()
  register_cancel_infos()
}

register_actions_infos()
